"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const ConexionesM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== "auto") {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 18 18" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M13.755 14.09a2.2 2.2 0 112.207-2.2 2.206 2.206 0 01-2.207 2.2M5.6 6.321a2.125 2.125 0 112.126 2.122A2.126 2.126 0 015.6 6.321m-3.2 6.16a1.285 1.285 0 111.306-1.306A1.3 1.3 0 012.4 12.481m5.334 3.475a.9.9 0 11.9-.9.9.9 0 01-.9.9M2.4 2.887a.9.9 0 11.9-.9.9.9 0 01-.9.9m12.417.439a1.032 1.032 0 11-1.032 1.032 1.033 1.033 0 011.032-1.032m-1.062 5.255a3.276 3.276 0 00-2.1.775L10.337 8.2a3.185 3.185 0 00.614-1.877c0-.083-.019-.16-.024-.24l2.081-.614a2.127 2.127 0 003.946-1.107 2.134 2.134 0 00-4.266 0v.053l-2.03.6a3.216 3.216 0 00-5.223-.959l-1.287-1.11a1.979 1.979 0 00.252-.959 2 2 0 00-4 0 2 2 0 002 2 1.966 1.966 0 00.964-.26L4.81 4.966a3.159 3.159 0 00.28 3.205L3.912 9.322A2.37 2.37 0 002.4 8.775 2.413 2.413 0 104.592 10.2l1.275-1.25a3.2 3.2 0 003.681.027l1.384 1.216a3.21 3.21 0 00-.245 2.906l-1.44.663a2.125 2.125 0 10.459 1l1.564-.719a3.3 3.3 0 102.486-5.463" }))));
};
exports.default = ConexionesM;
//# sourceMappingURL=index.js.map